import React from 'react';

const ABOUT_IMAGE = `${process.env.PUBLIC_URL || ''}/images/section-images/${encodeURIComponent('homeaboutus.jpg')}`;

export default function HomeWelcome(): React.ReactElement {
  return (
    <section id="about" className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:px-12 lg:py-12">
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-8">
          {/* Text Content Section - Left */}
          <div className="flex flex-col justify-center">
            <div className="text-left">
              <h2 className="text-2xl font-semibold leading-tight text-slate-900 sm:text-3xl">
                Welcome to Ancient Engineering
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base">
                Ancient Engineering is a Zimbabwean-owned firm dedicated to bridging the
                gap between traditional industrial processes and modern technological
                advancement. As a multi-discipline partner, we provide turnkey
                solutions in the Process Industry, Electrical, Mechanical, and
                Automation sectors. We don&apos;t just fix machines; we engineer
                intelligent factory answers.
              </p>
            </div>
          </div>

          {/* Image Section - Right */}
          <div className="order-first lg:order-last">
            <div className="relative h-full max-h-[220px] w-full overflow-hidden rounded-xl bg-slate-100 sm:max-h-[250px]">
              <img
                src={ABOUT_IMAGE}
                alt="Ancient Engineering"
                className="h-full w-full object-cover object-top"
                loading="lazy"
                onError={(e) => {
                  console.error('Failed to load image:', ABOUT_IMAGE);
                  console.log('Trying to load from:', ABOUT_IMAGE);
                }}
                onLoad={() => {
                  console.log('HomeWelcome image loaded successfully:', ABOUT_IMAGE);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
